// extracted by mini-css-extract-plugin
export default {"cls1":"EmailRegistrationPage-cls1_qbO","cls2":"EmailRegistrationPage-cls2_T4X EmailRegistrationPage-cls1_qbO"};